import React, { useState } from "react";
import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import Zone from "./Zone/Zone";
import Region from "./Region/Region";
import Area from "./Area/Area";
import District from "./District/District";
import Mandal from "./Mandal/Mandal";
import Village from "./Village/Village";

const tabs = ["Zone", "Region", "Area", "District", "Mandal", "Village"];

const Location = () => {
  const [activeTab, setActiveTab] = useState("Zone");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box minHeight="100vh">
      {/* Tabs */}
      {/* For xs: fixed bottom, 3 per row, 2 rows. For sm+: original style */}
      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
          mt: { xs: 0, sm: 8, md: 0 },
          position: { xs: "fixed", sm: "static" },
          left: 0,
          bottom: { xs: 0, sm: "auto" },
          zIndex: 1200,
          bgcolor: { xs: "#fff", sm: "transparent" },
          boxShadow: { xs: "0px -2px 12px rgba(0,0,0,0.08)", sm: "none" },
          p: { xs: 1, sm: 0 },
        }}
      >
        {/* xs: grid, sm+: inline-flex */}
        <Box
          sx={{
            display: { xs: "grid", sm: "inline-flex" },
            gridTemplateColumns: { xs: "repeat(3, 1fr)", sm: "none" },
            gridTemplateRows: { xs: "repeat(2, 1fr)", sm: "none" },
            gap: 1,
            p: 1,
            borderRadius: { xs: 0, sm: "14px" },
            bgcolor: { xs: "#fff", sm: "#fff" },
            boxShadow: { xs: "none", sm: "0px 4px 12px rgba(0,0,0,0.08)" },
            width: { xs: "100%", sm: "max-content" },
            overflowX: { xs: "hidden", sm: isMobile ? "auto" : "visible" },
            whiteSpace: { xs: "normal", sm: "nowrap" },
          }}
        >
          {tabs.map((tab, idx) => (
            <Button
              key={tab}
              onClick={() => setActiveTab(tab)}
              sx={{
                px: { xs: 0, sm: 3 },
                py: { xs: 1, sm: 1 },
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 300,
                fontSize: { xs: "13px", sm: "14px" },
                color: activeTab === tab ? "#fff" : "#333",
                bgcolor: activeTab === tab ? "#4F46E5" : "transparent",
                boxShadow:
                  activeTab === tab
                    ? "0px 4px 10px rgba(79,70,229,0.35)"
                    : "none",
                "&:hover": {
                  bgcolor:
                    activeTab === tab ? "#4F46E5" : "rgba(0,0,0,0.04)",
                },
                flexShrink: 0,
                minWidth: { xs: 0, sm: 80 },
                width: { xs: "100%", sm: "auto" },
                m: { xs: 0, sm: 0 },
              }}
            >
              {tab}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ mt: { xs: 2, sm: 3 }, mb: { xs: 8, sm: 0 } }}>
        {activeTab === "Zone" && <Zone />}
        {activeTab === "Region" && <Region />}
        {activeTab === "Area" && <Area />}
        {activeTab === "District" && <District />}
        {activeTab === "Mandal" && <Mandal />}
        {activeTab === "Village" && <Village />}
      </Box>
    </Box>
  );
};

export default Location;
